<template>
  <div
    class="home"
    style="background-color: #f7f8f9"
  >
    <!-- 
     -->
    <div
      class="bH"
      :style="{
        backgroundImage: 'url(' + (isEnter ? bh_center2 : bh_center) + ')',
      }"
    >
      <div
        class="bh_left"
        :style="{
          backgroundImage: 'url(' + require('@/assets/home/bh_left.svg') + ')',
        }"
      />

      <div
        class="bh_right"
        :style="{
          backgroundImage: 'url(' + require('@/assets/home/bh_right.svg') + ')',
        }"
      ></div>

      <div class="body">
        <div class="title">
          提供5合1顾客到店服务
        </div>
        <div class="sub_title">
          大人来也为客户提供大人体验官、达人探店、神秘顾客、轻咨询、需求洞察服务，有效促进顾客到店，<span style="color: #ff7831">增消费，降成本，促声量</span>
        </div>
        <div class="sub_title2">
          <div>大人来也为客户提供大人体验官、</div>
          <div>达人探店、神秘顾客、轻咨询、需求洞察服务</div>
          <div>有效促进顾客到店，<span style="color: #ff7831">增消费，降成本，促声量</span></div>
        </div>
        <div class="desc">
          大人来也调查平台建立了一个由客户自主发布任务的模式，平台拥有一张覆盖全国的实名顾客和专家网络，一套完整的B2C模式。为超过100多家组织、机构和公司提供顾客调查、神秘顾客、探店体验等个性化服务。

        </div>
        <div
          class="desc_show_btn"
          @click="showDesc()"
        >
          了解更多<i class="el-icon-arrow-down"></i>
        </div>
        <div class="desc2">
          <div>
            大人来也调查平台建立了一个由客户自主发布任务的模式，
          </div>
          <div>平台拥有一张覆盖全国的实名顾客和专家网络，一套完整的B2C模式。</div>
          <div>
            为超过100多家组织、机构和公司提供顾客调查、神秘顾客、探店体验等个性化服务。
          </div>

        </div>
        <div class="downloadApp">
          <span
            class="icon iconfont"
            @mouseenter="downloadAppHandleEnter('download_app')"
            @mouseleave="downloadAppHandleLeave('download_app')"
          >&#xe642;</span>
          <span
            @mouseenter="downloadAppHandleEnter('download_app')"
            @mouseleave="downloadAppHandleLeave('download_app')"
          ><span
              class="gj"
              @click="openGj()"
            >调研估价器+</span>
            <!-- 
            <span
              class="gj"
              @click="openGJzs()"
            >估价助手</span>+
            -->
            <span
              class="gj"
              @click="open('https://work.weixin.qq.com/kfid/kfcac88be45ee8d1bc4')"
            >服务咨询</span></span>
          <div class="content">
            <img
              :style="{ display: isEnter ? 'block' : 'none' }"
              :src="require('@/assets/home/H-Teacher.png')"
            />
            <svg
              :style="{ display: isEnter ? 'block' : 'none' }"
              fill="none"
              width="892"
              height="300"
              viewBox="0 0 892 186"
            >
              <defs>
                <mask id="a">
                  <rect
                    width="892"
                    height="186"
                    rx="0"
                    fill="#FFF"
                  ></rect>
                </mask>
                <filter
                  id="b"
                  filterUnits="objectBoundingBox"
                  color-interpolation-filters="sRGB"
                  x="0"
                  y="0"
                  width="800"
                  height="554"
                >
                  <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                  ></feFlood>
                  <feBlend
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  ></feBlend>
                  <feGaussianBlur
                    in="BackgroundImage"
                    stdDeviation="5"
                  ></feGaussianBlur>
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_foregroundBlur"
                  ></feComposite>
                  <feBlend
                    in="SourceGraphic"
                    in2="effect1_foregroundBlur"
                    result="shape"
                  ></feBlend>
                </filter>
                <linearGradient
                  x1=".5"
                  y1=".679"
                  x2=".5"
                  y2="1"
                  id="c"
                >
                  <stop
                    offset="0%"
                    stop-color="#FFF"
                    stop-opacity="0"
                  ></stop>
                  <stop
                    offset="42.618%"
                    stop-color="#FFF"
                    stop-opacity=".85"
                  ></stop>
                  <stop
                    offset="100%"
                    stop-color="#F8F9FA"
                    stop-opacity=".75"
                  ></stop>
                </linearGradient>
                <linearGradient
                  x1=".5"
                  x2=".5"
                  y2="1"
                  id="d"
                >
                  <stop
                    offset="63.704%"
                    stop-color="#FFF"
                    stop-opacity="0"
                  ></stop>
                  <stop
                    offset="100%"
                    stop-color="#FFF"
                    stop-opacity=".5"
                  ></stop>
                </linearGradient>
              </defs>
              <g
                filter="url(#b)"
                mask="url(#a)"
              >
                <ellipse
                  cx="442"
                  cy="-98"
                  rx="400"
                  ry="277"
                  fill="url(#c)"
                ></ellipse>
                <ellipse
                  cx="442"
                  cy="-98"
                  rx="399"
                  ry="276"
                  stroke="url(#d)"
                  stroke-width="2"
                ></ellipse>
              </g>
            </svg>
          </div>
        </div>
        <div class="downloadAppH5">
          <span
            class="icon iconfont"
            style="color: #4a8ee9"
            @mouseenter="downloadAppHandleEnter('download_app')"
            @mouseleave="downloadAppHandleLeave('download_app')"
          >&#xe642;</span>
          <span
            @mouseenter="downloadAppHandleEnter('download_app')"
            @mouseleave="downloadAppHandleLeave('download_app')"
          ><span
              class="gj"
              style="color: #4a8ee9;font-weight: bolder;"
              @click="openGjH5()"
            >调研估价器</span>+<span
              @click="open('https://work.weixin.qq.com/kfid/kfcac88be45ee8d1bc4')"
              style="color: #4a8ee9;font-weight: bolder;"
            >服务咨询</span></span>
        </div>
      </div>
    </div>

    <trends
      :data="trendsData"
      @showAll="
        () => {
          $router.push('/drlyTrends');
        }
      "
    />

    <evaluate
      v-if="evalShow"
      @close="
        () => {
          evalShow = false;
        }
      "
    />
    <!-- <beautiful-chat
      :participants="participants"
      :titleImageUrl="titleImageUrl"
      :onMessageWasSent="onMessageWasSent"
      :messageList="messageList"
      :newMessagesCount="newMessagesCount"
      :isOpen="isChatOpen"
      :close="closeChat"
      :icons="icons"
      :open="openChat"
      :showEmoji="false"
      :showFile="false"
      :showEdition="true"
      :showDeletion="true"
      :showTypingIndicator="showTypingIndicator"
      :showLauncher="true"
      :showCloseButton="true"
      :colors="colors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :disableUserListToggle="false"
      :messageStyling="messageStyling"
      :showHeader="false"
      :placeholder="chatPlaceStr"
      @onType="handleOnType"
      @edit="editMessage">
      <template v-slot:text-message-body="{ message }">
        <p style="white-space: pre-line;">
          {{message.data.text}}
        </p>
      </template>
    </beautiful-chat> -->

  </div>
</template>

<script>
import trends from "@/components/home/trends.vue";
import evaluate from "@/components/evaluate.vue";

export default {
  components: {
    trends,
    evaluate,
  },
  props: {},
  data() {
    return {
      evalShow: false,
      trendsData: [
        {
          "guid": "1851193389484085250",
          "title": "商家如何通过调查抓牢消费动线中的“触点”？",
          "trendsDesc": "对餐饮和零售企业来说，门店的消费动线是提升服务质量、优化空间布局和增加顾客满意度的关键步骤。无论店型大小，都离不开合理的动线设计。依托于丰富多样的新技术新手段，经营者能从数据层面获取大量的动线优化依据，而大人来也顾客体验式调查，除了满足经营者对门店运营质量的需求，也有助于持续监测消费动线的合理性，尤其是牵涉到人员介入的消费“触点”，帮助企业更好地理解顾客需求。",
          "trendsGuid": "1851193389484085250",
          "headImage": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-29/image/41182bc56579e78247808c85029d1a5b.png",
          "headImageMax": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-29/image/1009a2675d49985ef6babc54fc770aa1.png",
          "headImageMin": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-29/image/fbce9e0286b8dad5c414830f3e9aff74.png",
          "contentLink": "https://mp.weixin.qq.com/s/2_FbPB2Wl3owjb_ijlcDiA",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-10-27T09:24:32.000+00:00",
          "updateTime": "2024-10-27T09:24:32.000+00:00",
          "sort": 1
        },
        {
          "guid": "1848548077502205953",
          "title": "当执行探店任务时，你该注意什么？",
          "trendsDesc": "评估员们，你是否碰到过在执行任务时神色慌张，填写问卷时手忙脚乱，提交问卷后因回答不完整，缺少重要照片凭证而问卷打回...如果有这些情况，请认真看一下本篇探店执行指南。",
          "trendsGuid": "1848548077502205953",
          "headImage": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-22/image/7c6523aadab9a1c413dc43879bbaba29.png",
          "headImageMax": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-22/image/cc32071ecd3d2902fe7888b37d352a1d.png",
          "headImageMin": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-22/image/99215dc5985204b73427ef70596004a9.png",
          "contentLink": "https://mp.weixin.qq.com/s/_uXqe0ziX20evy_AN2vFLQ",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-10-20T02:13:01.000+00:00",
          "updateTime": "2024-10-22T02:13:01.000+00:00",
          "sort": 1
        },
        {
          "guid": "1848293851597377538",
          "title": "当我们在审核报告时，我们在审核什么？",
          "trendsDesc": "无论评估员还是商户，经常会问我们：你们的问卷报告需要后台审核，请问审核标准是什么？这篇文章就来回答这个问题。",
          "trendsGuid": "1848293851597377538",
          "headImage": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-21/image/d3371988acee476df15e8a7621c09c4a.png",
          "headImageMax": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-21/image/fbc573d55ee73d6ca11e9afae7f8ea19.png",
          "headImageMin": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-21/image/c5281521b2531d875c2c427195b9114a.png",
          "contentLink": "https://mp.weixin.qq.com/s/KlkoKKYB2U1zT_ez7Csv2Q",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-10-20T09:22:49.000+00:00",
          "updateTime": "2024-10-21T09:22:49.000+00:00",
          "sort": 2
        },
        {
          "guid": "1115947061030686734",
          "title": "资深评估员线上报名指南",
          "trendsDesc": "【大人来也】资深评估员开始招募啦，各位未来的资深评估员们，想要报名成功，请按照以下的步骤进行线上报名：PART.01完成平台的实名初级认证、PART.02填写【资深评估员报名】问卷、PART.03进入【学习驿站】, 完成培训视频的学习观看、PART.04完成【2024年下半年度资深评估员培训考核问卷】。",
          "trendsGuid": "1115947061030686734",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/2f64256ffe48add14d1f855b04a7727c.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/eee45dc245dc68fff5d2e136d10ad854.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/9ed96a98ef83ca3cd58bc8733ca6751e.png",
          "contentLink": "https://mp.weixin.qq.com/s/QVtItUQkvoUd2s_EBVV3pQ",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-09-22T03:40:47.000+00:00",
          "updateTime": "2024-09-22T03:40:47.000+00:00",
          "sort": 3
        },
        {
          "guid": "1115947061030686730",
          "title": "操作培训｜异常签到，消费凭证，自带相机，录音",
          "trendsDesc": "随着产品不断升级，【大人来也】将定期为资深评估员提供操作培训，确保平台任务得以高质量完成。",
          "trendsGuid": "1115947061030686730",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/e343fdeef09d71f525d3f4fcaf720efc.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/d142bf9d68fef59dbc6e50ba5878f6b3.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/6708faa13da68907711297a019711cfc.png",
          "contentLink": "https://mp.weixin.qq.com/s/WXmZMD4igclllFXKR3LX-w",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-09-01T03:45:53.000+00:00",
          "updateTime": "2024-09-01T03:46:02.000+00:00",
          "sort": 4
        },
        {
          "guid": "1115947061030686729",
          "title": "资深评估员 持续升级中",
          "trendsDesc": "在我们的“大人”中，有这么一群人——资深评估员。\n\n\n\n我们正式地向您介绍那些在各自领域中发挥着至关重要作用的资深评估员。作为具有高度专业素养与责任感的实名制现场评估专家，他们凭借多年的丰富经验和深厚的知识底蕴，成为了调研行业的佼佼者。",
          "trendsGuid": "1115947061030686729",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/a35c506fab98f584d60f7035703dc17b.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/a499ec5d6a37b5e64af32377a99e6986.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/d95a82ae3af0586d5b34e34700f89b5f.png",
          "contentLink": "https://mp.weixin.qq.com/s/0xekYCiTM2cVp2lWbiynZw",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-09-01T03:45:53.000+00:00",
          "updateTime": "2024-09-01T03:46:02.000+00:00",
          "sort": 5
        },
        {
          "guid": "1115947061030686736",
          "title": "学界专家研讨华米模式实践价值",
          "trendsDesc": "9月29日，以“包容协作治理理论”及华米模式实践价值为主题的研讨会在上海成功举办。来自上海交通大学、浙江大学、华东师范大学、无锡市文广旅游局等高校、政府部门的专家学者、业界代表，共同探讨了包容协作治理理论的缘起、国内外应用现状、华米模式实践成效，结合我国社会特点，对未来发展提出了切实可行的建议。",
          "trendsGuid": "1115947061030686736",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-04/image/e9d9bbabcf356b5a0a6ab68a465c5d08.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-04/image/626b1b2101a5183df9b18d57902f92e9.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-04/image/d57ecb88519be25c3ff355a1b3afb315.png",
          "contentLink": "https://mp.weixin.qq.com/s/ni2Xz8SbXMf2C6RGVpbWbg",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-10-01T15:58:29.000+00:00",
          "updateTime": "2024-10-01T15:58:33.000+00:00",
          "sort": 6
        },
        {
          "guid": "1115947061030686737",
          "title": "一种让消费者更信赖企业的调查方式",
          "trendsDesc": " 大人来也平台与用户，在这些年来，共绘成长蓝图，在双向奔赴中见证彼此成长。用户的期待是平台前行的动力，平台的努力则为用户铺设更宽广的道路。在携手共进的路上，我们正在打造一种新的收入模式，希望能持续提供对商家、对用户都有利的多赢格局。\n\n",
          "trendsGuid": "1115947061030686737",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-30/image/4dfdb165c81edffde06b316f18aeaefe.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-30/image/5ad16c51ffaec6186337dab3e8f0f348.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-30/image/d5ac9140af4ddc2d9cde1879d0f233d0.png",
          "contentLink": "https://mp.weixin.qq.com/s/IdS8Fmf0LdQS6mn1uU7JFw",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-10-13T01:42:51.000+00:00",
          "updateTime": "2024-10-13T01:42:59.000+00:00",
          "sort": 7
        },
        {
          "guid": "1115947061030686733",
          "title": "通过体验式调查，实现个人素养提升和企业责任落实",
          "trendsDesc": "近十年来，大人来也通过实名制评估的方式，为企业和政府的数据治理打磨出一块新的拼图。\n\n大人来也不仅是一个为完成调查任务使用的“工具”，也是开展教育的平台。通过参与社会治理，参与者更可以学习到相关法律知识、公共政策和社会规范，也可以了解到企业在经营中的管理标准，从而提升自身的素养和参与能力。\n\n在接单任务前，用户首先要通过任务说明了解该任务的性质、目标。在做出基本判断，且完成接单后，用户还需要在线学习任务要求，“预习”问卷，熟知现场调研操作基本规范。\n\n一位参与过多次企业体验式调查的用户说，现在对服务行业的同理心增强了，因为他知道看似普通的工作，背后有这么多的条条框框，对于一些非恶意的不周到，与其与员工发生冲突，不如心平气和好好沟通。\n\n参与过政务调研项目的用户说，填了几份不同的调研问卷，就看到政府管理中的细致，以前遇到不满意的情况，要么置之不理，私下抱怨，要么就选择投诉。现在看到有些管理部门能主动邀请群众参与体验评价，这个沟通方式更理性，更充分，也令人对这样的部门心生好感。\n\n平台在任务前置设计的培训板块，在某种程度可以被视作组织的宣教引导阵地。例如，一份文旅调研问卷要求“神秘游客”前往游客中心了解相关服务，也相当于推广介绍了游客中心应有的服务，这一部分恰恰是被游客忽略的内容；一家火锅品牌“培训”用户，需要观察锅底是否在点单后5分钟内上桌，这变相地宣传了品牌在出餐效率上的精细化亮点。\n\n平台鼓励机制有助于激发主动意识，无论是通过自身的服务获取酬劳，还是看到提出的建议得到落实，都使组织与个人之间产生良性的互动，更高的黏性。\n\n平台不仅提供参与社会治理的机会，也通过多元化的教育内容和形式，全面提升公民的素养和能力。这种教育与实践相结合的模式，有效地促进了公民的全面发展，为构建知识型、责任型、参与型的现代社会奠定了坚实的基础。通过这样的平台，公民不仅能够更好地参与和影响社会治理，还能够在个人成长和社会进步中找到自己的价值和意义。\n\n与此同时，大人来也为组织提供指引，做好“企业中的第三方”。",
          "trendsGuid": "1115947061030686733",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/17389423e4af195f7188fdb9f14dd37b.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/d801d0d82b0c5233215f1924c0083e06.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/48828bb95b40b166cb06c31724098158.png",
          "contentLink": "https://mp.weixin.qq.com/s/bJsgCpOOvaSru_MkJRAB6w",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-09-22T03:40:47.000+00:00",
          "updateTime": "2024-09-22T03:40:47.000+00:00",
          "sort": 8
        }
      ],
      isEnter: false,
      bh_center: require("@/assets/home/bh_center.svg"),
      bh_center2: require("@/assets/home/bh_center2.svg"),
      //chatbox
      participants: [
        {
          id: 'me',
          name: '访客',
          imageUrl: 'https://media.darenlaiye.com/drlylogo.png'
        },
        {
          id: 'user2',
          name: '报价助手',
          imageUrl: 'https://media.darenlaiye.com/drlylogo.png'
        }
      ],
      titleImageUrl: 'https://media.darenlaiye.com/drlylogo.png',
      messageList: [
        { type: 'text', author: `user2`, data: { text: `为了给您生成一个准确的报价单，请您先回答以下几个问题：\n\n1. 本次任务需要调查多少家门店？\n2. 每家门店需要进行几次调查？\n3. 门店的人均消费大概是多少？\n4. 通常情况下，顾客是几人同行？\n\n根据您的回答，我将能够快速为您生成一个可行性调研的估价结果。请您提供以上信息。` } }
      ],
      chatPlaceStr: "请输入您的问题",
      newMessagesCount: 0,
      isChatOpen: false,
      showTypingIndicator: '',
      colors: {
        header: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        launcher: {
          bg: '#ed4b35'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#ed4b35',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      },
      alwaysScrollToBottom: false,
      messageStyling: false,
      chatSessionId: null,
    };
  },
  watch: {},
  computed: {
    baseUrl() {
      if (location.href.indexOf("www.darenlaiye.com") > 0) {
        return "https://e.darenlaiye.com/application/api";
      }
      return "https://e_test.darenlaiye.com/application/api";
    },
  },
  methods: {
    getTrendsData() {
      this.requestApi("admin.drly.company.website.drly.trends.sort.list.gw", {})
        .then((resp) => {
          this.trendsData = resp.data.list;
        })
        .catch((err) => { })
        .finally(() => { });
    },

    requestApi(actions, params) {
      params.platform = "guanwang";
      return new Promise((resolve, reject) => {
        fetch(`${this.baseUrl}?action=${actions}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ params: params }),
        })
          .then((response) => response.json()) // 如果服务器返回JSON，则解析它
          .then((resp) => {
            if (resp.code == 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          }) // 处理服务器返回的数据
          .catch((error) => {
            reject(error);
          }); // 处理错误
      });
    },
    openGj() {
      this.evalShow = true;
    },
    openGJzs() {
      this.isChatOpen = true;
    },
    openGjH5() {
      if (location.href.includes("darenlaiye.com")) {
        window.open("https://e.darenlaiye.com/wxapp/#/appraisal?isShare=1")
      } else {

        window.open("https://e_test.darenlaiye.com/wxapp/#/appraisal?isShare=1")
      }
    },
    open(url) {
      window.open(url);
    },
    downloadAppHandleEnter() {
      this.isEnter = true;
    },
    downloadAppHandleLeave() {
      this.isEnter = false;
    },
    showDesc() {
      console.log(this.$(".desc2"));
      this.$(".desc_show_btn").css("display", "none");
      this.$(".desc2").css("display", "block");
    },
    //chatbox部分
    sendMessage(text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
        this.onMessageWasSent({ author: 'me', type: 'text', data: { text } })
      }
    },
    onMessageWasSent(message) {
      // 当用户发送消息时调用
      this.messageList = [...this.messageList, message];

      var msg2 = { author: 'user2', type: 'text', data: { text: `思考中...` } };

      this.messageList = [...this.messageList, msg2];
      var that = this;
      const jsonData = JSON.stringify({
        sessionId: this.chatSessionId,
        prompt: message.data.text
      });
      var progress = 0;
      var contentLength = 0;
      //连接aichat
      // 发送POST请求
      fetch('//yygj.darenlaiye.com/meraxmtest/api/ChatBot/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: jsonData
      })
        .then(async (response) => {
          contentLength = response.headers.get('Content-Length');

          const reader = response.body.getReader();
          const decoder = new TextDecoder('utf-8');

          while (true) {
            const { done, value } = await reader.read();

            if (done) {
              console.log('Stream complete');
              break;
            }
            if (progress == 0) {
              msg2.data.text = "";
            }
            progress += 1;

            // 将二进制数据解码为字符串
            const chunk = decoder.decode(value, { stream: true });
            console.log('Received chunk:', chunk);
            //this.receivedData += chunk;
            var aimsg = JSON.parse(chunk);
            that.chatSessionId = aimsg.output.session_id;
            // 可以在这里实时更新 UI 或处理数据
            //console.log('Received text:', aimsg.output.text);
            msg2.data.text += aimsg.output.text;
          }
          //console.log(response);
        }) // 如果服务器返回JSON，则解析它
        // .then((resp) => {
        //   console.log("+++++++++++++++resp+++++++++++++++++");
        //   console.log(resp);
        //   if (resp.data && resp.data.base64) {
        //     let fileName = resp.data.file_name;
        //     const link = document.createElement("a");
        //     link.href = `data:application/pdf;base64,${resp.data.base64}`;
        //     link.download = fileName;
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //   }
        // }) // 处理服务器返回的数据
        .catch(error => console.error('Error:', error));

    },
    openChat() {
      // 当用户单击fab按钮打开聊天时调用
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat() {
      // // 当用户单击按钮关闭聊天时调用
      this.isChatOpen = false
    },
    handleScrollToTop() {

      // 当用户将消息列表滚动到顶部时调用
      // 利用分页来加载另一个消息页面

    },
    handleOnType() {
      console.log('Emit typing event')
    },
    editMessage(message) {
      const m = this.messageList.find(m => m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    }
  },
  created() { },
  mounted() {
    this.trendsData = [];
    this.getTrendsData();
  },
};
</script>
<style lang='less' scoped>
/* 特定于桌面的样式 */
@media screen and (min-width: 1280px) {
  .bH {
    max-height: 442px;
    padding-top: 80px;
    .body {
      max-height: 362px;
      .desc2 {
        display: none !important;
      }
      .desc_show_btn {
        display: none;
      }
      .downloadApp {
        padding-top: 24px;
        color: #111925;
        font-size: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: center;

        font-weight: 500;
        line-height: 1;
        position: relative;
        .icon {
          color: #111925;
          font-size: 1.5rem;
          line-height: 1;
          margin-right: 0.25rem;
          margin-top: 2.5px;
        }
        .content {
          position: absolute;
          top: 3rem;
          img {
            position: absolute;
            width: 190px;
            height: 190px;
            left: calc(50% - 95px);
            top: 20px;
          }
        }
        /deep/ .gj {
          cursor: pointer;
        }
        /deep/ .gj:hover {
          cursor: pointer;
          text-decoration: underline;
          color: #4a8ee9;
        }
      }
      .downloadAppH5 {
        display: none;
      }
    }
  }
}
/* 特定于移动设备的样式 */
@media screen and (max-width: 1279px) {
  .bH {
    max-height: 422px;

    padding-top: 60px;
    .body {
      max-height: 362px;
      padding-bottom: 0px !important;
      .desc2 {
        display: none;
      }
      .desc_show_btn {
        display: none;
      }
      .downloadApp {
        display: none !important;
      }
      .downloadAppH5 {
        margin-top: 24px;
        font-size: 1rem;
        text-align: center;
      }
    }
  }
}
/* 特定于移动设备的样式 */
@media screen and (max-width: 1024px) {
  .bH {
    .bh_left {
      display: none;
    }
    .bh_right {
      display: none;
    }
    .body {
      //   padding-top: 3rem !important;
      padding-bottom: 0px !important;
      .title {
        font-size: 1.5rem !important;
      }
      .sub_title {
        display: none !important;
      }
      .sub_title2 {
        display: block !important;
        margin: 0px auto;
        margin-top: 32px;
        font-size: 0.875rem;
        line-height: 1.6;
        color: #111925;
        text-align: center;
        width: 90%;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
      .desc {
        display: none !important;
      }
      .desc2 {
        font-size: 0.75rem;
        line-height: 1.6;
        color: rgba(15, 25, 37, 0.65);
        text-align: center;
        width: 90%;
        margin: 0px auto;
        margin-top: 0.5em;
        display: none;
      }
      .desc_show_btn {
        padding-bottom: 30px;
        padding-top: 1.5rem;
        font-size: 0.75rem;
        line-height: 1.6;
        display: block;
        text-align: center;
        i {
          margin-left: 3px;
        }
      }
      .downloadApp {
        display: none;
      }
      .downloadAppH5 {
        margin-top: 7px;
        font-size: 1rem;
        text-align: center;
      }
    }
  }
}
.bH {
  background-color: #f7f8f9;
  width: 100%;
  position: relative;
  background-position: top;
  background-size: auto 400px;
  background-repeat: no-repeat;
  .bh_left {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 400px;

    height: 400px;
  }
  .bh_center {
    position: absolute;
    top: -10%;
    left: 0%;
    width: 100%;
  }
  .bh_right {
    position: absolute;
    top: 0px;
    right: 0px;
    height: 400px;
    width: 200px;
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .body {
    min-height: 362px;
    max-width: 1280px;
    margin: 0px auto;
    position: relative;
    padding-top: 3.75rem;
    padding-bottom: 2rem;
    z-index: 1;
    background: transparent;
    .title {
      font-size: 3.25rem;
      line-height: 1.6;
      text-align: center;
      color: #111925;
      font-weight: bolder;
    }
    .sub_title {
      margin: 0px auto;
      margin-top: 32px;
      font-size: 1.5rem;
      line-height: 1.6;
      text-align: center;
      color: #111925;
      font-weight: bolder;
      width: 90%;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
    }
    .sub_title2 {
      display: none;
    }
    .desc {
      font-size: 0.875rem;
      line-height: 1.6;
      color: rgba(15, 25, 37, 0.65);
      text-align: center;
      width: 90%;
      margin: 0px auto;
      margin-top: 2em;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
    }
  }
}
</style>